+function () {

	"use strict";

	var profilesContainer = $('.team-profiles');

	if (profilesContainer.length == 0) {
		return;
	}

	var history = new DbbHistoryState(true, window.appConfig.pagePathname);
	//history.setNativePushStateSupport(false);
	
	var showTeamMemberModal = function(teamMeberDomElement) {
		var profile = $(teamMeberDomElement).closest('.sticker-list__item');

		var memberName = profile.find('.sticker-list__member-name').html();
		var jobPosition = profile.find('.sticker-list__job-position').html();
		var socialLinks = profile.find('.sticker-list__social-link-list').html();
		var profileImage = profile.find('.sticker-list__item-icon').attr('src');
		var story = profile.find('.sticker-list__story').html();
		var quote = profile.find('.sticker-list__quote').html();
		var sport = profile.find('.sticker-list__sport').html();

		var modal = $('#modal');

		var modalContent = $($('.team-profiles-modal-template').clone().html());

		modalContent.find('.team-profiles-modal__icon').attr('src', profileImage);
		modalContent.find('.team-profiles-modal__name').html(memberName);
		modalContent.find('.team-profiles-modal__job-position').html(jobPosition);
		modalContent.find('.team-profiles-modal__social-link-list').html(socialLinks);
		modalContent.find('.team-profiles-modal__story').html(story);
		modalContent.find('.team-profiles-modal__section--quote .team-profiles-modal__section-content').html(quote);
		modalContent.find('.team-profiles-modal__section--sport .team-profiles-modal__section-content').html(sport);

		modal.find('.modal-content').html(modalContent);

		modal.modal('show');
		
		modal.one('hide.bs.modal.program', function () {
			history.push({}, 'default', '');
		});
	};
	
	profilesContainer.find('.sticker-list__item-link').on('click', function () {

		var state = {
			'target' : '#modal',
			'href' : this.href
		};

		history.push(state, state.href, state.href.replace(window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/', ''));
		
		showTeamMemberModal(this);

		return false;

	});
	
	$(window).on('onDbbHistoryStatePop', function () {
		if (history.getState() == null || $.isEmptyObject(history.getState())) {
			if (($('.modal:not(#videoModal)').is('visible')) || ($('.modal:not(#videoModal)').data('bs.modal'))) {
				$('.modal').off('hide.bs.modal.program').modal('hide');
			}
			return;
		}

		var teamMemberLink = profilesContainer.find('a[href="' + history.getState().href + '"]');

		teamMemberLink.trigger('click');
	});
	
	$(document).on('ready.team.profile.modal', function () {

		var hash = window.location.hash.replace(/^(#!)/, '');

		if (hash != '') {
			var modalUrl = window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/' + hash;

			profilesContainer.find('a[href="' + modalUrl + '"]').addClass('load-on-page-request');
		}

		$('.load-on-page-request').each(function () {

			var state = {
				'target' : '#modal',
				'href' : this.href
			};

			history.replace(state, state.href, state.href.replace(window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/', ''));

			$(this).trigger('click', true);
		});
	});

}(window.jQuery);
